
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface RouteContextProps {
  previousRoute: string | null;
  currentRoute: string;
  navigateBack: () => void;
  navigateTo: (path: string) => void;
}

const RouteContext = createContext<RouteContextProps>({
  previousRoute: null,
  currentRoute: '/',
  navigateBack: () => {},
  navigateTo: () => {},
});

export const RouteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [previousRoute, setPreviousRoute] = useState<string | null>(null);
  const [currentRoute, setCurrentRoute] = useState<string>(location.pathname);

  useEffect(() => {
    if (location.pathname !== currentRoute) {
      setPreviousRoute(currentRoute);
      setCurrentRoute(location.pathname);
    }
  }, [location.pathname, currentRoute]);

  const navigateBack = () => {
    if (previousRoute) {
      navigate(previousRoute);
    } else {
      navigate('/');
    }
  };

  const navigateTo = (path: string) => {
    navigate(path);
  };

  return (
    <RouteContext.Provider value={{ previousRoute, currentRoute, navigateBack, navigateTo }}>
      {children}
    </RouteContext.Provider>
  );
};

export const useRoute = () => useContext(RouteContext);

export default RouteContext;
